(() => {
  if (window.dlPremiumSizeGuideInitialized) return;

  window.dlPremiumSizeGuideInitialized = true;

  let lastFocusedElement = null;

  const findDrawer = (drawerId) => {
    return document.querySelector(
      `[data-dl-size-guide-drawer="${drawerId}"]`
    );
  };

  const findTrigger = (drawerId) => {
    return document.querySelector(
      `[data-dl-size-guide-open="${drawerId}"]`
    );
  };

  const openSizeGuide = (drawerId) => {
    const drawer = findDrawer(drawerId);

    if (!drawer) return;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    lastFocusedElement = document.activeElement;

    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dl-size-guide-open');

    const trigger = findTrigger(drawerId);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    const closeButton = drawer.querySelector(
      '[data-dl-size-guide-close]'
    );

    if (closeButton) {
      window.requestAnimationFrame(() => {
        closeButton.focus();
      });
    }
  };

  const closeSizeGuide = (drawerId) => {
    const drawer = findDrawer(drawerId);

    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dl-size-guide-open');

    const trigger = findTrigger(drawerId);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus === 'function'
    ) {
      lastFocusedElement.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest(
      '[data-dl-size-guide-open]'
    );

    if (openButton) {
      event.preventDefault();

      openSizeGuide(
        openButton.dataset.dlSizeGuideOpen
      );

      return;
    }

    const closeButton = event.target.closest(
      '[data-dl-size-guide-close]'
    );

    if (closeButton) {
      event.preventDefault();

      closeSizeGuide(
        closeButton.dataset.dlSizeGuideClose
      );
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const visibleDrawer = document.querySelector(
      '[data-dl-size-guide-drawer][aria-hidden="false"]'
    );

    if (visibleDrawer) {
      closeSizeGuide(
        visibleDrawer.dataset.dlSizeGuideDrawer
      );
    }
  });
})();
